import { isNil, unless } from 'ramda';

export const parseSportId = unless(isNil, Number);

export const formatSportId = unless(isNil, String);

export * from './updateFilterWithNewCategories';
export * from './updateFilterWithNewSport';
export * from './updateFilterWithNewTournaments';
